// extracted by mini-css-extract-plugin
module.exports = {"saved-search-labels":"c6e8ba5398--saved-search-labels--2oaIy"};